import { JoinedContest } from "interfaces/leaderboard/contest.ts";
import { getContestById } from "state/slices/contests-slice.ts";
import { useAppSelector } from "state/hooks.ts";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import TimeDisplay from "./shared/time-display.tsx";
import { ContestNameDisplay, ContestStatusDisplay, EntryFeeDisplay } from "./shared/contest-displays";
import ContestInfoContainer from "./shared/contest-displays/contest-info-container.tsx";
import { getGroupState } from "state/slices/group-slice.ts";
import { getContestEntryFee, getContestPagePath } from "utils/contest-group-utils.ts";

interface Props {
  joinedContest: JoinedContest;
}

const JoinedContestItem = ({ joinedContest }: Props) => {

  const contest = useAppSelector((state) => getContestById(state, joinedContest.contest_id));
  const groupId = useAppSelector(getGroupState).id;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(getContestPagePath(contest?.id || "", groupId), {
      state: {
        contestEntryId: joinedContest.entries[0].id,
      }
    });
  };

  if (!contest) {
    return <></>;
  }

  const nameFlex = .6;
  const feeFlex = (1 - nameFlex) / 2;

  const userEntriesCount = joinedContest.entries.length;
  const maxEntriesPerUser = contest.max_entries_per_user;
  const topText = maxEntriesPerUser
    ? `${userEntriesCount}/${maxEntriesPerUser}`
    : `${userEntriesCount}/∞`;
  const bottomText = "My Entries";

  return (
    <div className={styles.wrapper} onClick={handleClick}>
      <div className={styles.contestContainer}>
        <div className={styles.infoRow}>
          <div style={{ flex: nameFlex }}>
            <ContestNameDisplay name={contest.name} />
            <TimeDisplay endAt={contest.end_at} />
          </div>

          <div style={{ flex: feeFlex }}>
            <EntryFeeDisplay entryFee={getContestEntryFee(contest, groupId)} />
          </div>

          <div style={{ flex: feeFlex }}>
            <ContestInfoContainer topText={topText} bottomText={bottomText} />
          </div>
        </div>
        <ContestStatusDisplay status={contest.state} />
      </div>
    </div>
  );

};

export default JoinedContestItem;